export const LOGO = "/logo.png"

export const SUPPORT_EMAIL = "info@encircled.org"

export const COPYRIGHT_TEXT = "Encircled. All rights reserved."

export const PRIVACY_POLICY_URL = "https://www.encircled.org/privacy-policy"

export const TERMS_OF_SERVICE_URL = "https://www.encircled.org/terms-of-service"